/**
 * Type of trading events
 */
export var TRADING_EVENT_TYPE;
(function (TRADING_EVENT_TYPE) {
    TRADING_EVENT_TYPE[TRADING_EVENT_TYPE["OPEN"] = 1] = "OPEN";
    TRADING_EVENT_TYPE[TRADING_EVENT_TYPE["CLOSE"] = 2] = "CLOSE";
})(TRADING_EVENT_TYPE || (TRADING_EVENT_TYPE = {}));
export var PREDEFINED_EOD_RANGES = {
    FIVE_DAYS: {
        diffOperator: 'substract',
        diff: [5, 'day'],
        diffStartOf: 'day',
    },
    ONE_MONTH: {
        diffOperator: 'substract',
        diff: [1, 'month'],
        diffStartOf: 'day',
    },
    THREE_MONTHS: {
        diffOperator: 'substract',
        diff: [3, 'month'],
        diffStartOf: 'day',
    },
    SIX_MONTHS: {
        diffOperator: 'substract',
        diff: ['6', 'month'],
        diffStartOf: 'day',
    },
    YTD: {
        diffOperator: 'startOf',
        diff: ['year'],
        diffStartOf: 'day',
    },
    ONE_YEAR: {
        diffOperator: 'substract',
        diff: [1, 'year'],
        diffStartOf: 'day',
    },
    TWO_YEARS: {
        diffOperator: 'substract',
        diff: [2, 'year'],
        diffStartOf: 'isoWeek',
        diffIntervals: [1, 'weeks'],
    },
    THREE_YEARS: {
        diffOperator: 'substract',
        diff: [3, 'year'],
        diffStartOf: 'isoWeek',
        diffIntervals: [1, 'weeks'],
    },
    FIVE_YEARS: {
        diffOperator: 'substract',
        diff: [5, 'year'],
        diffStartOf: 'isoWeek',
        diffIntervals: [1, 'weeks'],
    },
    SEVEN_YEARS: {
        diffOperator: 'substract',
        diff: [7, 'year'],
        diffStartOf: 'isoWeek',
        diffIntervals: [2, 'weeks'],
    },
    TEN_YEARS: {
        diffOperator: 'substract',
        diff: [10, 'year'],
        diffStartOf: 'isoWeek',
        diffIntervals: [2, 'weeks'],
    },
    MAX: {
        diffOperator: 'substract',
        diff: [20, 'year'],
        diffStartOf: 'isoWeek',
        diffIntervals: [4, 'weeks'],
    },
};
//# sourceMappingURL=constants.js.map